import React from "react";
import { Box, Typography, TextField, Select, MenuItem } from "@mui/material";

const CartSummary = ({
  cartTotals,
  totalInvDiscPercent,
  onTotalInvDiscChange,
  totalInvDiscType = "percentage",
  onTotalInvDiscTypeChange,
  isEditMode = false,
  showTotalQtyOnly = false,
  hideTotalInvDisc = false,
}) => {
  const totalQty =
    (Number(cartTotals.boxCount) || 0) + (Number(cartTotals.pieceCount) || 0);

  return (
    <Box sx={{ mt: 0, mx: -2, borderRadius: 0 }}>
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#F4F6F8",
          overflowX: "auto",
          border: "1px solid #E7E7E7",
          borderLeft: 0,
          borderRight: 0,
        }}
      >
        {showTotalQtyOnly ? (
          <>
            <Box
              sx={{
                width: 120,
                borderRight: "1px solid #E7E7E7",
                p: 0.8,
              }}
            >
              <Typography
                variant="caption"
                fontWeight={600}
                noWrap
                px={2}
              >
                Total Qty : {totalQty}
              </Typography>
            </Box>
            <Box
              sx={{
                width: 160,
                borderRight: "1px solid #E7E7E7",
                p: 0.8,
              }}
            >
              <Typography
                variant="caption"
                fontWeight={600}
                noWrap
                px={1}
              >
                Total Discount : £{(cartTotals.lineDiscountTotal || 0).toFixed(2)}
              </Typography>
            </Box>
          </>
        ) : (
          <>
            <Box
              sx={{
                width: 100,
                borderRight: "1px solid #E7E7E7",
                p: 0.8,
              }}
            >
              <Typography
                variant="caption"
                fontWeight={600}
                noWrap
                px={2}
              >
                Box : {cartTotals.boxCount || 0}
              </Typography>
            </Box>
            <Box
              sx={{
                width: 100,
                borderRight: "1px solid #E7E7E7",
                p: 0.8,
              }}
            >
              <Typography
                variant="caption"
                fontWeight={600}
                noWrap
              >
                Piece : {cartTotals.pieceCount || 0}
              </Typography>
            </Box>
          </>
        )}
        <Box
          sx={{
            flex: 1,
            minWidth: 190,
            borderRight: "1px solid #E7E7E7",
            p: 0.8,
          }}
        >
          <Typography
            variant="caption"
            fontWeight={600}
            noWrap

          >
            Zero VAT Goods : £{(cartTotals.zeroGoods || 0).toFixed(2)}
          </Typography>
        </Box>
        <Box
          sx={{
            flex: 1,
            minWidth: 150,
            borderRight: "1px solid #E7E7E7",
            p: 0.8,
          }}
        >
          <Typography
            variant="caption"
            fontWeight={600}
            noWrap
    
          >
            VAT Goods : £{(cartTotals.stdGoods || 0).toFixed(2)}
          </Typography>
        </Box>
        <Box
          sx={{
            flex: isEditMode ? 1 : 0,
            minWidth: 110,
            borderRight: "1px solid #E7E7E7",
            p: 0.8,
          }}
        >
          <Typography
            variant="caption"
            fontWeight={600}
            noWrap

          >
            VAT : £{(cartTotals.vat || 0).toFixed(2)}
          </Typography>
        </Box>

        {isEditMode && !hideTotalInvDisc && (
          <Box
            sx={{
              flex: 1.5,
              minWidth: 180,
              borderRight: "1px solid #E7E7E7",
              p: 0.8,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          
              <Typography
                variant="caption"
                fontWeight={600}
                sx={{ whiteSpace: "nowrap" }}
              >
                Total Inv Disc:
              </Typography>

              <TextField
                size="small"
                className="input-border"
                type="number"
                value={totalInvDiscPercent ?? ""}
                // disabled={isDisabled}
                onChange={(e) => {
                  const v = e.target.value;
                  onTotalInvDiscChange?.(v === "" ? "" : Number(v));
                }}
                onFocus={(e) => e.target.select()}
                inputProps={{
                  step: "0.01",
                  min: "0",
                  max: totalInvDiscType === "percentage" ? "100" : undefined,
                }}
                sx={{
                  width: 60,
                  background: "#fff",
                  borderRadius: 1,
                  borderColor: "#000",
                  "& .MuiInputBase-input": {
                    fontSize: "0.75rem",
                    p: 0.5,
                    textAlign: "center",
                    
                  },
                }}
              />
              {/* {onTotalInvDiscTypeChange && (
                <Select
                  value={totalInvDiscType}
                  onChange={(e) => onTotalInvDiscTypeChange(e.target.value)}
                  size="small"
                  sx={{
                    height: 32,
                    fontSize: "0.7rem",
                    minWidth: 50,
                    "& .MuiSelect-select": {
                      py: 0.5,
                      fontSize: "0.7rem",
                    },
                  }}
                >
                  <MenuItem value="percentage">%</MenuItem>
                  <MenuItem value="amount">£</MenuItem>
                </Select>
              )} */}
            </Box>
          </Box>
        )}


        <Box
          sx={{
            flex: 1.5,
            minWidth: 160,
            backgroundColor: "#ffd399",
            color: "#000",
            p: 0.8,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="caption" fontWeight={600} noWrap>
            Grand Total : {(cartTotals.grandTotal || 0).toFixed(2)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CartSummary;
